import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../auth.service';
import {environment} from '../../../environments/environment';
import {ComponentBase} from '../../core/entities/component-base';


@Component({
  selector : 'app-login',
  templateUrl : './login.component.html',
  styleUrls : ['./login.component.scss']
})
export class LoginComponent extends ComponentBase implements OnInit {
  username: string;
  password: string;
  profile: string;
  errorMessage: string;

  // Second-factor step: after a 202 challenge, hide the credentials form and reveal a code input.
  awaitingCode = false;
  code: string;
  private challengeToken: string;

  constructor(private _router: Router) {
    super();
  }

  ngOnInit() {
  }

  login() {
    this.errorMessage = null;
    this.authService.login({pwd: this.password, userid: this.username, profile: this.profile }).subscribe(res => {
      if (res && res.user) {
        this._router.navigateByUrl(environment.homePage);
      } else if (res && res.challengeToken) {
        // 2FA required: stash the challenge token and switch the form to the code step.
        this.challengeToken = res.challengeToken;
        this.awaitingCode = true;
      } else {
        this.errorMessage = 'Username/passaword errati!';
      }
    }, () => {
      this.errorMessage = 'Username/passaword errati!';
    });
  }

  verify() {
    this.errorMessage = null;
    this.authService.verify2FA(this.challengeToken, this.code).subscribe(user => {
      if (user) {
        this._router.navigateByUrl(environment.homePage);
      } else {
        this.errorMessage = 'Codice errato!';
      }
    }, () => {
      // Wrong / expired code -> stay on the code step and show the error.
      this.errorMessage = 'Codice errato!';
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/auth/login/login.component.ts